import { useEffect, useState } from 'react';
import { HeadWrapper, Wrapper, Head, Title } from './orders-admin-page.styles';
import { Button } from '@vtbhome/juicyfront';
import { ArrowsChevronLeft } from '@vtbhome/juicyfront/indexIcon';
import { useHistory } from 'react-router-dom';
import { useOrdersListSharedQuery } from '@entities/order/libs/hooks/use-orders-list-shared-query/use-orders-list-shared-query';
import { OrdersListDataRequest } from '@entities/order/api/order-types';
import { ListOrdersManagement } from '@widgets/list-orders-management/ui/list-orders-management';
import { DownloadOrders } from '@features/order/download-orders/ui/download-orders';
import { ModalOrderDetailedInfo } from '@widgets/modal-order-detailed-info/modal-order-detailed-info';
import { DEFAULT_ORDERS_LIST_ADMIN_PARAMETERS } from './constants';
import { FilterListOrder } from '@features/order/filter-list-orders/ui/filter-list-orders';
import { SortOrders } from '@features/order/sort-orders/ui/sort-orders';
import { useSearchParams } from '@shared/lib/hooks/use-search-params/use-search-params';

export const OrdersAdminPage = () => {
    const history = useHistory();

    const [ordersParameters, setOrdersParameters] = useSearchParams<OrdersListDataRequest>({
        ...DEFAULT_ORDERS_LIST_ADMIN_PARAMETERS,
    });
    const [getOrders] = useOrdersListSharedQuery(ordersParameters);
    const [orderCardId, setOrderCardId] = useState<number>();

    useEffect(() => {
        getOrders(ordersParameters);
    }, [ordersParameters]);

    const handleClickOrderCardId = (id: number) => {
        setOrderCardId(id);
    };

    return (
        <>
            <Wrapper>
                <HeadWrapper>
                    <Head>
                        {Boolean(history.length) && (
                            <Button
                                round
                                size='xl'
                                buttonType='secondary'
                                startAdornment={<ArrowsChevronLeft />}
                                onClick={() => history.goBack()}
                            />
                        )}
                        <Title size='h6'>Сделки</Title>
                        <FilterListOrder parameters={ordersParameters} setParameters={setOrdersParameters}>
                            <DownloadOrders />
                        </FilterListOrder>
                    </Head>
                    <SortOrders parameters={ordersParameters} setParameters={setOrdersParameters} />
                </HeadWrapper>
                <ListOrdersManagement
                    ordersParameters={ordersParameters}
                    setOrdersParameters={setOrdersParameters}
                    onClickOrderCard={handleClickOrderCardId}
                />
            </Wrapper>

            <ModalOrderDetailedInfo
                isShow={Boolean(orderCardId)}
                orderId={orderCardId}
                onClose={() => setOrderCardId(undefined)}
            />
        </>
    );
};
